import React, { useEffect, useState } from 'react';
import { X, MapPin, CalendarDays, ArrowRight } from 'lucide-react';

// Printing United show promo popup.
// Auto-hidden after this date (inclusive through Sep 25, 2026).
const END_DATE = new Date('2026-09-26T00:00:00');
const SESSION_KEY = 'pn_printing_united_seen';
const BANNER_SRC = '/printing-united-banner.png';

const PrintingUnitedPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (new Date() >= END_DATE) return;                 // campaign expired
    if (sessionStorage.getItem(SESSION_KEY)) return;    // once per session
    const t = setTimeout(() => setOpen(true), 900);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    sessionStorage.setItem(SESSION_KEY, '1');
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-[#050F2E]/70 backdrop-blur-sm animate-fade-up"
      data-testid="printing-united-popup"
      onClick={close}
    >
      <div
        className="relative w-full max-w-2xl bg-white rounded-3xl overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={close}
          data-testid="printing-united-popup-close"
          className="absolute top-3 right-3 z-10 h-10 w-10 rounded-full bg-[#050F2E]/80 hover:bg-[#050F2E] text-white flex items-center justify-center shadow-lg"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>

        <img src={BANNER_SRC} alt="ProofNation at Printing United 2026 — Booth C3245" className="w-full object-cover" data-testid="printing-united-banner" />

        <div className="p-6 md:p-8">
          <p className="text-xs uppercase tracking-[0.3em] text-[#FF4E50] font-bold mb-2">You&apos;re invited</p>
          <h3 className="text-2xl md:text-3xl font-black text-[#050F2E] tracking-tight">
            Meet us at Printing United — Las Vegas
          </h3>
          <p className="mt-3 text-slate-600 leading-relaxed">
            ProofNation will be exhibiting at the Printing United Show in Las Vegas during the expo.
            Come see our proofing, spectrophotometer and color-management solutions live — we&apos;d love to show you around.
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-4 text-sm font-semibold text-[#0A2A63]">
            <span className="inline-flex items-center gap-2"><MapPin className="h-4 w-4 text-[#E5007E]" /> Booth C3245</span>
            <span className="inline-flex items-center gap-2"><CalendarDays className="h-4 w-4 text-[#00B7C7]" /> Printing United 2026 · Las Vegas</span>
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href="/contact" onClick={close}>
              <button className="inline-flex items-center gap-2 bg-[#0A2A63] hover:bg-[#061a3f] text-white rounded-full h-12 px-7 font-bold btn-transition" data-testid="printing-united-cta">
                Book a meeting <ArrowRight className="h-4 w-4" />
              </button>
            </a>
            <button onClick={close} className="rounded-full h-12 px-6 font-bold text-[#0A2A63] hover:bg-slate-100 btn-transition">
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintingUnitedPopup;
